import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { ShieldCheck, Loader2, XCircle } from "lucide-react";
import { endpoints, setTenantScope } from "@/lib/api";
import { toast } from "sonner";

export default function AuditorEntryPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ loading: true, error: null, session: null });

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState({ loading: false, error: "Missing token in link", session: null }); return; }
    endpoints.auditorSession(token).then((session) => {
      setTenantScope({ role: "auditor", token, slug: session.client_slug, company_name: session.client_name, allowed_areas: session.allowed_areas, auditor_name: session.auditor_name, expires_at: session.expires_at });
      setState({ loading: false, error: null, session });
      toast.success(`Welcome ${session.auditor_name} — read-only auditor session`);
      setTimeout(() => navigate(`/clients/${session.client_slug}`, { replace: true }), 800);
    }).catch((e) => {
      const detail = e.response?.data?.detail || "Access unavailable";
      setState({ loading: false, error: String(detail), session: null });
    });
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 ambient-bg">
      <div className="glass-card rounded-3xl p-10 max-w-md w-full text-center">
        <div className="mx-auto h-14 w-14 rounded-2xl bg-gradient-to-br from-purple-600 to-indigo-600 text-white flex items-center justify-center mb-4 shadow-lg">
          <ShieldCheck className="h-6 w-6" />
        </div>
        <h1 className="font-display text-xl font-extrabold mb-2">Auditor portal access</h1>
        {state.loading && (
          <div className="flex items-center justify-center gap-2 text-sm text-slate-500 mt-4">
            <Loader2 className="h-4 w-4 animate-spin" /> Validating your one-time link...
          </div>
        )}
        {state.error && (
          <>
            <div className="flex items-center justify-center gap-2 text-rose-600 mt-4"><XCircle className="h-5 w-5" /> {state.error}</div>
            <p className="text-xs text-slate-500 mt-3">Please contact your ISOQuest administrator to request a new invite.</p>
          </>
        )}
        {state.session && (
          <p className="text-sm text-slate-600 mt-4">
            Signed in as <strong>{state.session.auditor_name}</strong> for <strong>{state.session.client_name}</strong>.<br />
            Redirecting to the read-only client portal…
          </p>
        )}
      </div>
    </div>
  );
}
